import { FC } from 'react';
import {
  BackArrow,
  Check,
  ChevronDown,
  Close,
  Discord,
  Google,
  Mail,
  Medium,
  Profile,
  Search,
  SoundMuted,
  SoundPlaying,
  Replies,
  Telegram,
  Wallet,
  X,
  Reposts,
  Error,
  Spinner,
  Edit,
  Plus,
  LinkedIn,
  Document,
  Tokenomics,
  Clock,
  Binance,
  PlayButton,
  View,
  Repost,
  Comment,
  Like,
  Bookmark,
  ArbitromSepolia,
  Socials,
  Youtube,
  External,
  RightArrow,
  Invest,
  Quest,
  Pulse,
  Partnerships,
  Roadmap,
  Home,
  Logout,
  Github,
  World,
  Voice,
  Instagram,
  PlayVideo,
  Growth,
  Money,
  Showcase,
  Socials2,
  QuestTesting,
  QuestBurn,
  QuestDiscord,
  QuestHodl,
  QuestReading,
  QuestReport,
  QuestWinning,
  Copy,
  Farcaster,
  Settings,
  Burger,
} from './Icons';
import { cn } from 'lib/utils';
import { Minus } from 'lucide-react'; // need to have svg icon in Figma
import { uiSimpleBox } from '../CutCorners';

interface BPIconProps {
  icon: keyof typeof icons;
  big?: boolean;
  small?: boolean;
  container?: 'none' | 'circle' | 'box';
  className?: string;
}

export const icons = {
  google: <Google />,
  mail: <Mail />,
  soundMuted: <SoundMuted />,
  soundPlaying: <SoundPlaying />,
  backArrow: <BackArrow />,
  rightArrow: <RightArrow />,
  wallet: <Wallet />,
  check: <Check />,
  profile: <Profile />,
  discord: <Discord />,
  x: <X />,
  twitter: <X />,
  telegram: <Telegram />,
  medium: <Medium />,
  chevronDown: <ChevronDown />,
  close: <Close />,
  replies: <Replies />,
  search: <Search />,
  reposts: <Reposts />,
  error: <Error />,
  spinner: <Spinner />,
  edit: <Edit />,
  plus: <Plus />,
  minus: <Minus />,
  linkedin: <LinkedIn />,
  instagram: <Instagram />,
  document: <Document />,
  tokenomics: <Tokenomics />,
  clock: <Clock />,
  binance: <Binance />,
  playButton: <PlayButton />,
  view: <View />,
  repost: <Repost />,
  comment: <Comment />,
  like: <Like />,
  bookmark: <Bookmark />,
  'arbitrum-sepolia': <ArbitromSepolia />,
  socials: <Socials />,
  socials2: <Socials2 />,
  youtube: <Youtube />,
  external: <External />,
  invest: <Invest />,
  quest: <Quest />,
  pulse: <Pulse />,
  partnerships: <Partnerships />,
  roadmap: <Roadmap />,
  home: <Home />,
  logout: <Logout />,
  voice: <Voice />,
  github: <Github />,
  world: <World />,
  website: <World />,
  playVideo: <PlayVideo />,
  growth: <Growth />,
  money: <Money />,
  showcase: <Showcase />,
  questTesting: <QuestTesting />,
  questBurn: <QuestBurn />,
  questDiscord: <QuestDiscord />,
  questHodl: <QuestHodl />,
  questReading: <QuestReading />,
  questReport: <QuestReport />,
  questWinning: <QuestWinning />,
  copy: <Copy />,
  farcaster: <Farcaster />,
  settings: <Settings />,
  burger: <Burger />,
};

const BPIcon: FC<BPIconProps> = ({
  icon,
  big = false,
  small = false,
  container = 'none',
  className = '',
}) => {
  const iconDisplay = (
    <div
      className={cn(
        'inline-grid relative place-items-center',
        className,
        big ? 'scale-[calc(32/24)]' : '',
        small ? 'scale-[calc(18/24)]' : ''
      )}
    >
      {icons[icon]}
    </div>
  );

  return (
    <>
      {container === 'none' && iconDisplay}
      {container === 'circle' && (
        <div
          className={cn(
            'inline-grid relative w-[32px] h-[32px] p-2 place-content-center rounded-full bg-white/1 backdrop-blur-lg border border-white/20'
          )}
        >
          {iconDisplay}
        </div>
      )}
      {container === 'box' && (
        <div
          className={cn(
            'inline-grid relative w-[40px] h-[40px] place-content-center rounded-[8px] bg-white/1 backdrop-blur-lg'
          )}
        >
          <div
            className={cn(
              'block absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/30 to-white/10',
              uiSimpleBox.border
            )}
          />
          {iconDisplay}
        </div>
      )}
    </>
  );
};

export default BPIcon;
